// @ts-check
import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { Paper } from '@material-ui/core';

import LocalShipping from '@material-ui/icons/LocalShipping';

const useStyles = makeStyles((theme) => ({
  paper: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    cursor: 'pointer'
  },
  icon: {
    fontSize: '4em'
  }
}));

export function PartnerMapComponent({ partner }) {
  const classes = useStyles();

  return (
    <>
      <Paper className={classes.paper} elevation={0}>
        <LocalShipping className={classes.icon} fontSize="large" />

        <div>
          <b>{partner.name}</b>
        </div>
      </Paper>
    </>
  );
}
